// extracted by mini-css-extract-plugin
export default {"Outer":"InputTitleWrap_Outer__uKvSj"};